/** Lower runs first. Creates must precede ops that need the ticket/units. */
const APPLY_RANK: Record<string, number> = {
  field_ticket_create: 0,
  redeem_deferred: 1,
  field_ticket_add_seat: 2,
  ticket_ops: 3,
  settle_topup: 4,
  settle_refund: 4,
  coupon_issue: 4,
  assignment: 5,
  checkin: 5,
  fee_payout: 6,
  cash_count: 6,
};

function applyRank(mutation: { kind?: string }) {
  return APPLY_RANK[mutation?.kind || ""] ?? 4;
}

function createdAtMs(mutation: { createdAt?: string }) {
  const ms = Date.parse(mutation?.createdAt || "");
  return Number.isFinite(ms) ? ms : 0;
}

/**
 * Dexie toArray() is by mutationId (UUID), not causality.
 * Sort the full outbox before chunking so create is never in a later HTTP request
 * than redeem / settle / assignment / checkin on the same ticket.
 */
export function orderMutationsForApply<T extends { kind?: string; mutationId?: string; createdAt?: string }>(
  mutations: T[],
): T[] {
  return [...mutations].sort((a, b) => {
    const rank = applyRank(a) - applyRank(b);
    if (rank) return rank;
    const time = createdAtMs(a) - createdAtMs(b);
    if (time) return time;
    return String(a?.mutationId || "").localeCompare(String(b?.mutationId || ""));
  });
}
